import { FC } from "react"
import { TeamPage as TeamPageContent } from "../../../components/LandingPage/TeamPage"

export const LandingTeamPage: FC = () => {
  return <TeamPageContent />
}
